module.exports = __webpack_public_path__ + "static/img/qh.ebed13f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jingmai/qh.png
// module id = 111
// module chunks = 0